const actionTypeIdentifier = '5A418C8D-91A0-4C94-A581-A4E818EFF666'; // to generate open ssms run select newid()

//location form actions
export const resetWirelessReplaceSimForm = `RESET-WIRELESS-REPLACE-SIM-FORM-${actionTypeIdentifier}`;
export const setUserLocation = `SET-WIRELESS-REPLACE-SIM-USER-LOCATION-${actionTypeIdentifier}`;
export const setSimOptions = `SET-WIRELESS-REPLACE-SIM-SIM-OPTIONS-${actionTypeIdentifier}`;
export const setCountryOptions = `SET-WIRELESS-REPLACE-SIM-COUNTRY-OPTIONS-${actionTypeIdentifier}`;
export const setAddressOptions = `SET-WIRELESS-REPLACE-SIM-ADDRESS-OPTIONS-${actionTypeIdentifier}`;
export const setSubscriptionDetails = `SET-WIRELESS-REPLACE-SIM-SUBSCRIPTION-DETAILS-${actionTypeIdentifier}`;
export const setShowOtherAddress = `SET-WIRELESS-REPLACE-SIM-SHOW-OTHER-ADDRESS-${actionTypeIdentifier}`;
export const setFormSubmitted = `SET-WIRELESS-REPLACE-SIM-FORM-SUBMITTED-${actionTypeIdentifier}`;


export const wirelessReplaceSimModel = {
    circuitCode: ''
    , circuitId: 0
    , countryCode: ''
    , country: ''
    , deliveryAddress: ''
    , deliveryAddressId: ''
    , otherLocationAddress: ''
    , simTypeId: 0
    , additionalInformation: ''
}